import iziToast, { IziToastSettings } from 'izitoast';
import { APP_TRANSLATE } from 'src/app/app-translate';
import Swal, { SweetAlertOptions } from 'sweetalert2';

const defaultSettings: IziToastSettings = {
  position: 'topRight',
  timeout: 5000,
};

const translate = (key: string, params?: Record<string, any>): string => {
  const res = APP_TRANSLATE?.instant?.(key, params);
  return typeof res === 'string' ? res : key;
};

export function alertSuccess(settings: IziToastSettings = {}) {
  return iziToast.success({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('SUCCESS'),
    message: ``,
    ...settings,
  });
}
export function alertWarning(settings: IziToastSettings = {}) {
  return iziToast.warning({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('ALERT'),
    message: ``,
    ...settings,
  });
}
export function alertInfo(settings: IziToastSettings = {}) {
  return iziToast.info({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('DATA'),
    message: ``,
    ...settings,
  });
}
export function alertDanger(settings: IziToastSettings = {}) {
  return iziToast.error({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('ERROR'),
    message: ``,
    ...settings,
  });
}

// -- แปลข้อความปุ่มตอนเปิดกล่องทุกครั้ง (เดิมแปลตอนโหลดไฟล์ ซึ่งยังไม่มี TranslateService ปุ่มจึงขึ้นเป็น CANCEL / CONFIRM ดิบ)
const defaultOptions = (): SweetAlertOptions => ({
  icon: 'warning',
  showCancelButton: true,
  showConfirmButton: true,
  cancelButtonText: translate('CANCEL'),
  confirmButtonText: translate('CONFIRM'),
  reverseButtons: true,
  focusCancel: true,
  confirmButtonColor: 'var(--bs-primary)',
});
export function alertConfirm(options: SweetAlertOptions = {}) {
  return Swal.fire({
    ...defaultOptions(),
    title: translate('CONFIRMATION'),
    // html: `คุณต้องการดำเนินการต่อ?`,

    ...Object.assign(
      {},
      {
        ...options,
        html: options.html || options.text || translate('DO_YOU_WANT_TO_CONTINUE'),
      },
    ),
  });
}
export function alertConfirmDanger(options: SweetAlertOptions = {}) {
  return Swal.fire({
    ...defaultOptions(),
    title: options.title ?? translate('CONFIRMATION'),
    // html: `คุณต้องการดำเนินการต่อ?`,
    confirmButtonColor: 'var(--bs-danger)',
    iconColor: 'var(--bs-danger)',
    ...Object.assign(
      {},
      {
        ...options,
        html: options.html || options.text || translate('DO_YOU_WANT_TO_CONTINUE'),
      },
    ),
  });
}

const alertTextMap = {
  formInvalid: 'PLEASE_FILL_IN_ALL_REQUIRED_FILEDS',
  saveSuccess: 'ALERT_SAVE_SUCCESS',
  loginSuccess: 'ALERT_LOGIN_SUCCESS',
  confirmDelete: 'DO_YOU_WANT_TO_DELETE_DATA',
  deleteSuccess: 'ALERT_DELETE_SUCCESS',
} as const;

// -- alertText.* แปลทุกครั้งที่อ่าน (getter) ไม่เก็บค่าที่แปลไว้ล่วงหน้า
// -- เดิม setAlertTextTranslations() แปลครั้งเดียวใน constructor ของ AppModule ตอนที่ไฟล์ภาษายังโหลดไม่เสร็จ
// -- ค่าจึงค้างเป็นชื่อ key ดิบ (เช่น PLEASE_FILL_IN_ALL_REQUIRED_FILEDS) และไม่เปลี่ยนตามภาษาที่ผู้ใช้เลือก
export const alertText = {} as Record<keyof typeof alertTextMap, string>;
(Object.keys(alertTextMap) as (keyof typeof alertTextMap)[]).forEach((key) =>
  Object.defineProperty(alertText, key, {
    enumerable: true,
    get: () => translate(alertTextMap[key]),
  })
);

export type AlertTextKey = keyof typeof alertTextMap;

// -- คงไว้ให้ AppModule เรียกได้เหมือนเดิม ตอนนี้ไม่ต้องทำอะไร เพราะ alertText แปลตอนอ่านแล้ว
export function setAlertTextTranslations(): typeof alertText {
  return alertText;
}

export function getAlertText(key: AlertTextKey): string {
  return alertText[key];
}

export function confirmDelete(text: string): string {
  return translate('CONFIRM_DELETE_ITEM', { text });
}
